import { Actions as AUTHENTICATION_ACTIONS } from "@/redux/actions/authenticationActions";
import { Actions as COMPANY_ACTIONS } from "@/redux/actions/companyActions";
import { Actions as EMPLOYEEACTIONS } from "@/redux/actions/employeeActions";
import { Actions as GROUPACTIONS } from "@/redux/actions/groupActions";
import { CheckCircleIcon } from "@heroicons/react/20/solid";
import cleanDeep from "clean-deep";
import { merge, setWith } from "lodash";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import Spinner from "../../common/Spinner";

const mfaOptions = [
	{ label: "Admins & Managers", value: 1 },
	{ label: "All Employees & Admins", value: 2 },
];

const General = ({
	handleLogoUpload,
	updateCompanyDetails,
	currentOrg,
	settings,
	profile,
	saving,
	setMFAModalStatus,
	hasMFA,
	disabled,
	setHMRCCredentialsModalStatus,
	isAdmin,
	jurisdictionOptions,
	jurisdiction,
	companyAdvisor,
	clientCanReview,
	isEnterprise,
	employeesGetList,
	groupOptions,
	autoEnrolmentPostponeOptions,
	getGroups,
	groups,
	defaultPensionGroup,
}) => {
	const [data, setData] = useState({});
	const updateField = (field, value) => {
		if (!field) return;
		if (field.includes("[")) field = setWith({}, field, value, Object);
		const newData = merge(data, { ...(typeof field == "object" ? field : { [field]: value }) });
		// console.debug(field, value)

		setData({ ...newData });
	};
	const isSameAdvisorAsUser = data?.advisor && profile.advisorId != data?.advisor;

	const onSubmit = (e) => {
		e.preventDefault();
		e.stopPropagation();

		updateCompanyDetails(
			cleanDeep(
				{
					org: String(currentOrg),
					...data,
				},
				{
					emptyStrings: false,
					emptyArrays: false,
					emptyObjects: false,
				},
			),
		);
	};

	useEffect(() => {
		if (!settings.org) return;

		setData({
			clientReviewsPayroll: settings?.clientReviewsPayroll,
			clientEntersPayrollData: settings?.clientEntersPayrollData,
			adminsCanProcessPayroll: settings?.adminsCanProcessPayroll,
			advisor: settings?.advisor,
			paidByAdvisor: settings?.paidByAdvisor,
		});
	}, [settings?.org, jurisdictionOptions?.length]);

	return (
		<>
			<form
				className="px-8"
				onSubmit={onSubmit}
			>
				{profile.isAdvisor && (
					<div className="form-section">
						<div className="col-xs-12 form-container">
							<h4>Advisor</h4>
						</div>
						{isAdmin && (
							<div className="col-xs-12">
								<input
									className="form-control"
									value={data?.advisor ? data?.advisor : ""}
									disabled={true}
								/>
							</div>
						)}
						<div className="col-xs-12 form-container">
							<div>
								<label
									className="css-input switch switch-sm switch-success"
									style={{
										cursor: disabled || (isAdmin && isSameAdvisorAsUser) ? "not-allowed" : "auto",
									}}
								>
									<input
										type="checkbox"
										value={profile.advisorId}
										checked={data?.advisor}
										disabled={disabled || (isAdmin && isSameAdvisorAsUser)}
										onChange={(e) => {
											updateField("advisor", e.target.checked ? profile.advisorId : false);
										}}
									/>
									<span /> Managed by {companyAdvisor?.name}
								</label>
								{data?.advisor && (
									<>
										<label
											className="css-input switch switch-sm switch-success"
											style={{
												cursor:
													disabled || (isAdmin && isSameAdvisorAsUser)
														? "not-allowed"
														: "auto",
											}}
										>
											<input
												type="checkbox"
												value={true}
												checked={data?.paidByAdvisor}
												disabled={disabled || (isAdmin && isSameAdvisorAsUser)}
												onChange={(e) => {
													// setValue('advisor',e.target.checked ? profile.advisorId : false, { shouldValidate: true,shouldDirty: true });
													updateField("paidByAdvisor", !data?.paidByAdvisor);
												}}
											/>
											<span /> Invoice {companyAdvisor?.name}
										</label>
										{clientCanReview && (
											<>
												<label
													className="css-input switch switch-sm switch-success"
													style={{
														cursor:
															disabled || (isAdmin && isSameAdvisorAsUser)
																? "not-allowed"
																: "auto",
													}}
												>
													<input
														type="checkbox"
														checked={data?.clientReviewsPayroll}
														disabled={disabled || (isAdmin && isSameAdvisorAsUser)}
														onChange={(e) => {
															updateField(
																"clientReviewsPayroll",
																!data?.clientReviewsPayroll,
															);
														}}
													/>
													<span /> Client Reviews Payroll
												</label>
												<label
													className="css-input switch switch-sm switch-success"
													style={{
														cursor:
															disabled || (isAdmin && isSameAdvisorAsUser)
																? "not-allowed"
																: "auto",
													}}
												>
													<input
														type="checkbox"
														checked={data?.clientEntersPayrollData}
														disabled={disabled || (isAdmin && isSameAdvisorAsUser)}
														onChange={(e) => {
															updateField(
																"clientEntersPayrollData",
																!data?.clientEntersPayrollData,
															);
														}}
													/>
													<span /> Client Enters Payroll Data
												</label>
											</>
										)}
										{/* {(clientCanReview || isEnterprise) && ( */}
										<label
											className="css-input switch switch-sm switch-success"
											style={{
												cursor: disabled ? "not-allowed" : "auto",
											}}
										>
											<input
												type="checkbox"
												checked={data?.adminsCanProcessPayroll}
												disabled={disabled}
												onChange={(e) => {
													updateField(
														"adminsCanProcessPayroll",
														!data?.adminsCanProcessPayroll,
													);
												}}
											/>
											<span /> Admins Can Process Payroll
										</label>
										{/* )} */}
									</>
								)}
							</div>
						</div>
						<div className="clearfix" />
					</div>
				)}

				<div className="col-span-3">
					{!disabled && (
						<div className="text-right">
							<button
								className="btn btn-success"
								type="submit"
							>
								{saving ? (
									<Spinner
										style={{ height: "1.5em", float: "left", marginRight: 5, float: "left" }}
										className="animate-spin -ml-1 mr-3 h-5 w-5"
									/>
								) : (
									<CheckCircleIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
								)}
								<div style={{ float: "left" }}>{saving ? "Saving..." : "Save"}</div>
							</button>
						</div>
					)}
					<div className="clearfix" />
				</div>
				<div className="clearfix" />
			</form>
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		isAdmin: state.my?.profile?.isAdmin,
		profile: state?.my?.profile,
		settings: state.company?.settings,
		currentOrg: state.company?.settings?.org,
		jurisdictionOptions: (state.jurisdictions || [])?.map(({ countryCode, name }) => ({
			label: `${name}/${countryCode}`,
			value: countryCode,
		})),
		disabled:
			state?.permissions?.my?.permissions?.settings == "Read" || state?.company?.settings?.status == "Archived",
		saving: state.company?.saving,
		jurisdiction: state.company?.settings?.jurisdiction,
		companyAdvisor: state.company?.advisor,
		isEnterprise: state.company?.advisor?.bureau === "Enterprise",
		clientCanReview: state.permissions?.plan?.clientReview,
	};
};

const mapDispatchToProps = (dispatch) => ({
	setHMRCCredentialsModalStatus: (status) => dispatch(COMPANY_ACTIONS.setHMRCCredentialsModalStatus(status)),
	employeesGetList: () => dispatch(EMPLOYEEACTIONS.employeesGetList()),
	updateCompanyDetails: (body) => dispatch(COMPANY_ACTIONS.updateCompanyDetails(body)),
	handleLogoUpload: (file, org) => dispatch(COMPANY_ACTIONS.handleLogoUpload({ file, org })),
	setMFAModalStatus: (status) => dispatch(AUTHENTICATION_ACTIONS.setMFAModalStatus(status)),
	getGroups: (options) => dispatch(GROUPACTIONS.getGroups(options)),
});

export default connect(mapStateToProps, mapDispatchToProps)(General);
